export default __webpack_public_path__ + "static/media/userTwo.1e712da5.svg";